import { useCheckDailyAndInvitesMutation } from "store/apis/userAPI"
import { useModal } from "context/ModalsContext"
import { clearLocalStorage } from "utils/clearLocalStorage"

export const useCheckDailyReward = () => {
  const { openModal } = useModal()

  const [checkDailyAndInvites] = useCheckDailyAndInvitesMutation()

  const checkDailyReward = async () => {
    await checkDailyAndInvites()
      .unwrap()
      .then((data) => {
        if (!data) openModal({ type: "dailyRewards" })
      })
      .catch((err) => {
        console.log("Error on checkDailyAndInvites", err)
        clearLocalStorage()
      })
  }

  return checkDailyReward
}
